/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevEventInboxMessageDto
 */
export interface DevEventInboxMessageDto {
    /**
     * 
     * @type {string}
     * @memberof DevEventInboxMessageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DevEventInboxMessageDto
     */
    topic: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevEventInboxMessageDto
     */
    sequence: number;
    /**
     * 
     * @type {string}
     * @memberof DevEventInboxMessageDto
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevEventInboxMessageDto
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevEventInboxMessageDto
     */
    subject: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DevEventInboxMessageDto
     */
    messageTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof DevEventInboxMessageDto
     */
    acknowledgedAt: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevEventInboxMessageDto
     */
    isProcessed: boolean;
}

/**
 * Check if a given object implements the DevEventInboxMessageDto interface.
 */
export function instanceOfDevEventInboxMessageDto(value: object): value is DevEventInboxMessageDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('topic' in value) || value['topic'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('messageTime' in value) || value['messageTime'] === undefined) return false;
    if (!('acknowledgedAt' in value) || value['acknowledgedAt'] === undefined) return false;
    if (!('isProcessed' in value) || value['isProcessed'] === undefined) return false;
    return true;
}

export function DevEventInboxMessageDtoFromJSON(json: any): DevEventInboxMessageDto {
    return DevEventInboxMessageDtoFromJSONTyped(json, false);
}

export function DevEventInboxMessageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevEventInboxMessageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'topic': json['topic'],
        'sequence': json['sequence'],
        'messageId': json['messageId'],
        'type': json['type'],
        'subject': json['subject'],
        'messageTime': (new Date(json['messageTime'])),
        'acknowledgedAt': (json['acknowledgedAt'] == null ? null : new Date(json['acknowledgedAt'])),
        'isProcessed': json['isProcessed'],
    };
}

export function DevEventInboxMessageDtoToJSON(json: any): DevEventInboxMessageDto {
    return DevEventInboxMessageDtoToJSONTyped(json, false);
}

export function DevEventInboxMessageDtoToJSONTyped(value?: DevEventInboxMessageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'topic': value['topic'],
        'sequence': value['sequence'],
        'messageId': value['messageId'],
        'type': value['type'],
        'subject': value['subject'],
        'messageTime': ((value['messageTime']).toISOString()),
        'acknowledgedAt': (value['acknowledgedAt'] == null ? null : (value['acknowledgedAt'] as any).toISOString()),
        'isProcessed': value['isProcessed'],
    };
}

